export default __webpack_public_path__ + "static/media/Icon_Class_Security.1ff869bd.png";